import { resolveImageUrl, resolveLink } from "@/storyblok/resolvers";
import { HeroBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";
import IconSuitcase from "../icons/IconSuitcase";
import IconPin from "../icons/IconPin";
import IconHours from "../icons/IconHours";
import IconSalary from "../icons/IconSalary";
import IconEducation from "../icons/IconEducation";
import IconChart from "../icons/IconChart";

export default function Hero({ data }: { data: HeroBlockData }) {
  return (
    <>
      <section
        id={data.anchor}
        className="hero"
        {...makeEditable(data)}
        style={{
          "--color-background": data.background_color?.color,
          "--color-text": data.text_color?.color,
        }}
      >
        <div className="container">
          <div className="col">
            <h1>{data.title}</h1>
            <div
              dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
            ></div>
            <div className="btn_row">
              {data.button1 && (
                <a
                  className="btn"
                  href={`#${data.button1.anchor}`}
                  {...makeEditable(data.button1)}
                >
                  {data.button1.label}
                </a>
              )}
              {data.button2 && (
                <a
                  className="btn btn-alt"
                  href={`#${data.button2.anchor}`}
                  {...makeEditable(data.button2)}
                >
                  {data.button2.label}
                </a>
              )}
            </div>
          </div>
          <div className="col">
            <img
              className="hero_img_desktop"
              src={resolveImageUrl(data.image, { height: 690 })}
              alt={data.image.alt}
            />
            <img
              className="hero_img_mobile"
              src={resolveImageUrl(data.image_mobile, { width: 576 })}
              alt={data.image_mobile.alt}
            />
          </div>
        </div>

        <div className="container">
          <ul>
            {data.branch && (
              <li>
                <IconSuitcase />
                <p>{data.branch}</p>
              </li>
            )}
            {data.location && (
              <li>
                <IconPin />
                <p>{data.location}</p>
              </li>
            )}
            {data.hours && (
              <li>
                <IconHours />
                <p>{data.hours}</p>
              </li>
            )}
            {data.salary && (
              <li>
                <IconSalary />
                <p>{data.salary}</p>
              </li>
            )}
            {data.education && (
              <li>
                <IconEducation />
                <p>{data.education}</p>
              </li>
            )}
            {data.experience && (
              <li>
                <IconChart />
                <p>{data.experience}</p>
              </li>
            )}
          </ul>
        </div>
      </section>
    </>
  );
}
